import { keepPreviousData, useQuery } from '@tanstack/react-query'

import type { ClinicId, StaffRole, TaskListStatus, TaskType } from '@snootsvet/shared'

import { useViewerRegion } from '@/frontend/features/region/region-context'
import { useOsApi } from '@/frontend/hooks/api/use-os-api'

type ListTasksFilters = {
  q?: string
  status?: TaskListStatus[]
  type?: TaskType
  patientId?: string
  assigneeStaffId?: string
  assigneeRole?: StaffRole
  assigneeClinicId?: ClinicId
  createdAfter?: string
  sortBy?: 'urgency' | 'due_date' | 'created_at'
  sortOrder?: 'asc' | 'desc'

  limit?: number
  offset?: number
}

type ListTasksOptions = {
  enabled?: boolean
  refreshInterval?: number
}

/** Lists tasks in the active region. */
export function useListTasks(filters?: ListTasksFilters, options?: ListTasksOptions) {
  const api = useOsApi()
  const { region } = useViewerRegion()
  const query = { ...filters, region }

  return useQuery({
    queryKey: ['tasks', query],
    enabled: options?.enabled ?? true,
    refetchInterval: options?.refreshInterval,
    // Keep the previous page visible while the next page loads — avoids a flash of empty state
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const response = await api.get('/tasks', { query })
      if (!response.success) throw new Error(response.error.message)
      return response.data
    },
  })
}
